export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ02.b846d5f3.mp3";